export default __webpack_public_path__ + "static/media/icon.84145818.svg";